import { createHttpClient } from "uicomponents";

// Single shared client. The per-request `x-source` header (set in api.ts) identifies the
// appeal scenario (account vs content) for the backend logs.
const httpClient = createHttpClient();

export default httpClient;